import React, { useContext, useState, useEffect } from "react";
import PostList from "../shared/PostList";
import { AppContext } from "../contexts/AppContext";
import { AuthContext } from "../contexts/AuthContext";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { getActiveNotificationCount } from "../store/actions/notificationAction";
import { getActiveChatNotificationCount } from "../store/actions/chatNotificationAction";
import axiosHttp from "../config/axios.interceptor";

const OtherUserPost = ({ isPromotion = false }) => {
  const appContext = useContext(AppContext);
  const { user, logout } = useContext(AuthContext);
  const [postList, setPostList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [isOpenArray, setIsOpenArray] = useState();
  const [initialLoad, setInitialLoad] = useState(false);
  const dispatch = useDispatch();
  const { id } = useParams();

  useEffect(() => {
    if (appContext.openModal === false) {
      setLoading(true);
      fetchPosts(1);
      setInitialLoad(true);
    } else {
      fetchPosts(page);
      setInitialLoad(true);
    }
  }, [appContext.openModal]);

  useEffect(() => {
    if (isPromotion) {
      appContext.updateCategory("680c89f84f3447f6da04284f");
    } else {
      appContext.updateCategory("");
    }
  }, [isPromotion]);

  useEffect(() => {
    let debounceTimeout;

    const handleScroll = () => {
      clearTimeout(debounceTimeout);

      debounceTimeout = setTimeout(() => {
        const scrollY = window.scrollY;
        const viewportHeight = window.innerHeight;
        const pageHeight = document.documentElement.scrollHeight;

        const scrollThreshold = 0.8;

        const distanceFromBottom = pageHeight - (scrollY + viewportHeight);

        if (
          distanceFromBottom / pageHeight <= 1 - scrollThreshold &&
          !loading &&
          initialLoad
        ) {
          fetchPosts(page);
        }
      }, 200);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [page, loading, initialLoad]);

  useEffect(() => {
    dispatch(getActiveNotificationCount());
    dispatch(getActiveChatNotificationCount());
  }, []);

  const reportPostHandler = (post) => {
    appContext.updateModalType("reportPost", "Report Post", post);
  };

  const fetchPosts = async (page, isDelete = false) => {
    // setLoading(true);
    try {
      // let userId = user?.userId || user?.data?.data?.userId;
      // if (userId) {
      const getPostsList = await axiosHttp.get(
        isPromotion
          ? `post-data/${id}?page=${page}&skillCategory=680c89f84f3447f6da04284f`
          : `post-data/${id}?page=${page}`
      );
      if (getPostsList.status === 200) {
        let data = getPostsList?.data?.data;
        if (page === 1) {
          setPostList(data);
        } else {
          setPostList([...postList, ...data]);
        }
        if (isDelete) {
          setPage(2);
        } else {
          setPage(page + 1);
        }
        setIsOpenArray(data.map(() => false));
        setLoading(false);
      }
      // }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      // appContext.updateNotificationState({
      //   show: true,
      //   message: errorResponseMessage(e),
      //   type: "error",
      // });
      //console.log(e);

      setLoading(false);
      setInitialLoad(false);
    }
  };

  const likePostHandler = async (id) => {
    try {
      const likePostResponse = await axiosHttp.post(`post/${id}/like`);
      if (likePostResponse.status === 201) {
        const updatedPostList = postList.map((post) => {
          if (post.id === id) {
            return {
              ...post,
              likeStatus: post.likeStatus === "Like" ? "DisLike" : "Like",
              postLikeCount:
                post.likeStatus === "Like"
                  ? post.postLikeCount - 1
                  : post.postLikeCount + 1,
            };
          }
          return post;
        });

        setPostList(updatedPostList);
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
    //console.log(error);
  };

  const toggleDiv = (index) => {
    const newIsOpenArray = [...isOpenArray];
    newIsOpenArray[index] = !newIsOpenArray[index];
    setIsOpenArray(newIsOpenArray);
  };

  const bookHandler = async (id) => {
    try {
      const bookPostResponse = await axiosHttp.post(`post/${id}/bookmark`);
      if (bookPostResponse.status === 201) {
        const updatedPostList = postList.map((post) => {
          if (post.id === id) {
            return {
              ...post,
              isBookmark:
                post.isBookmark === "Not" || post.isBookmark === "No"
                  ? "Yes"
                  : "Not",
            };
          }
          return post;
        });

        setPostList(updatedPostList);
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  return (
    <PostList
      loading={loading}
      postList={postList}
      likePostHandler={likePostHandler}
      reportPostHandler={reportPostHandler}
      // isEdit={true}
      expertiesKey="name"
      toggleDiv={toggleDiv}
      isOpenArray={isOpenArray}
      bookHandler={bookHandler}
    />
  );
};

export default OtherUserPost;
